import { Flex, Icon, SlimButton, Text } from 'components'
import { t } from 'i18next'
import { Trans } from 'react-i18next'
import {
  setOpenUploadMetaModal,
  setOpenUploadShareModal,
} from 'store/FairShareContext/fairShareSlice'
import { useDispatch } from 'store/store'
import { theme } from 'styles/theme/hav-theme'

import * as S from './styles'

interface EmptyShareProps {
  descriptionKey: 'bmu' | 'office'
  loadingUpload?: boolean
}

export const EmptyShare = ({ descriptionKey, loadingUpload }: EmptyShareProps) => {
  const dispatch = useDispatch()

  const handleUploadClick = () => {
    dispatch(setOpenUploadShareModal(true))
  }

  const handleMetaUploadClick = () => {
    dispatch(setOpenUploadMetaModal(true))
  }

  return (
    <S.Wrapper>
      <Flex alignItems="center" gap="md">
        <S.IconWrapper>
          <Icon color={theme.colors.ion.primary.onsofter} icon="percent" size="28" />
        </S.IconWrapper>
        <Flex direction="column" gap="xs">
          <Text color="stronger" size="md" weight="md">
            {t('screens.fairShare.emptyShareTitle')}
          </Text>
          <Text color="strong" size="xs">
            <Trans i18nKey={`screens.fairShare.emptyShareDescription_${descriptionKey}`} />
          </Text>
        </Flex>
      </Flex>

      <Flex alignItems="center" gap="md">
        {descriptionKey === 'office' && (
          <SlimButton
            content={t('screens.fairShare.loadMeta')}
            icon={<Icon icon="file-input" size="18" />}
            loading={loadingUpload}
            onClick={handleMetaUploadClick}
            type="button"
            variant="primary"
          />
        )}

        <SlimButton
          content={t('screens.fairShare.loadShare')}
          icon={<Icon icon="file-input" size="18" />}
          loading={loadingUpload}
          onClick={handleUploadClick}
          type="button"
          variant="primary"
        />
      </Flex>
    </S.Wrapper>
  )
}
